// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .ellipsis-btn .btn,\n.widget-rootwidget .ellipsis-btn .btn:hover,\n.widget-rootwidget .ellipsis-btn .btn:visited,\n.widget-rootwidget .ellipsis-btn .btn:active {\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none !important;\n  color: #343a40 !important;\n  font-size: 12px !important;\n}\n", ""]);
// Exports
module.exports = exports;
